export const SET_SELECTED_SPREAD = 'SET_SELECTED_SPREAD'
export const RUNES_RECEIVED = 'RUNES/RECEIVED'
export const RUNES_REQUEST_FAILED = 'RUNES/REQUEST_FAILED'
export const SPREADS_RECEIVED = 'SPREADS/RECEIVED'
export const SPREADS_REQUEST_FAILED = 'SPREADS/REQUEST_FAILED'
export const GET_RUNES = 'RUNES/FETCH'
export const GET_SPREADS = 'SPREADS/FETCH'
export const INIT = 'INIT'
